import { NavigationItem } from "../navigation-item"
import { SwapOverviewTab, SwapSettingsTab } from "../tabs/swap-tabs"

export class SwapNavigationItem extends NavigationItem {
  readonly id = "swap"
  readonly label = "Swap"
  readonly href = "/swap"
  readonly iconName = "swap-icon"
  readonly isExternal = false

  readonly tabs = [new SwapOverviewTab(), new SwapSettingsTab()]

  readonly subItems = []
}
